import React from 'react';
import cn from 'classnames';

import type { TDraftOffer } from '../models';
import commonStyles from '../styles/styles.css';

import styles from './styles/styles.css';

export const DraftOfferDesktop = ({
    Block,
    Button,
    ProgressBar,
    Text,
    TimerText,
    agreeButtonText,
    agreeDataLayerProps,
    agreeHref,
    cardLabel,
    disagreeButtonText,
    disagreeDataLayerProps,
    finalText,
    header,
    id,
    introText,
    onClickDisagree,
    progressBar,
    sendEvent,
    timetText,
    userName,
}: TDraftOffer) => {
    return (
        <Block className={cn(styles.wrapper, styles.external)} id={id} shadow>
            <Text styler={{ marginTop: 0, marginBottom: 32 }} view="medium">
                {header}
            </Text>
            {progressBar && (
                <>
                    <Text styler={{ marginTop: 0, marginBottom: 8 }} view="primary-small">
                        {progressBar.text}
                    </Text>
                    <ProgressBar
                        className={cn(commonStyles.progressBar, commonStyles.external)}
                        styler={{ marginBottom: 24 }}
                        {...progressBar}
                    />
                </>
            )}
            <Text styler={{ margin: 0 }}>
                {userName}
                {introText}
                {cardLabel}
                {finalText}
                {timetText && <TimerText {...timetText} />}
            </Text>
            <div className={styles.buttonsWrapper}>
                <Button
                    block
                    onClick={() => {
                        sendEvent(disagreeDataLayerProps);
                        onClickDisagree();
                    }}
                    size="s"
                    styler={{ marginRight: 16 }}
                >
                    {disagreeButtonText}
                </Button>

                <Button
                    block
                    href={agreeHref}
                    onClick={() => sendEvent(agreeDataLayerProps)}
                    size="s"
                    view="primary"
                >
                    {agreeButtonText}
                </Button>
            </div>
        </Block>
    );
};
